import { CSSProperties, ComponentPropsWithoutRef, FC } from 'react'
import { cn } from '~/src/lib/utils'

export interface AnimatedShinyTextProps
  extends ComponentPropsWithoutRef<'span'> {
  shimmerWidth?: number
  disabled?: boolean
}

export const AnimatedShinyText: FC<AnimatedShinyTextProps> = ({
  children,
  className,
  shimmerWidth = 100,
  disabled = false,
  ...props
}) => {
  return (
    <span
      style={
        {
          '--shiny-width': `${shimmerWidth}px`,
        } as CSSProperties
      }
      className={cn(
        'text-neutral-600/70 dark:text-neutral-400/70',

        // Only apply animation classes if not disabled
        !disabled && [
          'animate-shiny-text bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shiny-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite]',
          'bg-gradient-to-r from-transparent via-black/80 via-50% to-transparent dark:via-white/80',
        ],

        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}
